import IPayload from "../interfaces/IPayload";
import ISaldoInstalacao from "../interfaces/ISaldoInstalacao";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class SaldoInstalacaoService {
    async getById(id: string) {
        return await api.get<ISaldoInstalacao>(`${resources.saldoInstalacao}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<ISaldoInstalacao>(`${resources.saldoInstalacao}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.saldoInstalacao}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.saldoInstalacao}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.saldoInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }
}

export default new SaldoInstalacaoService();
